import * as React from "react";
import { Button, Container, Fade, Grid, Link, Menu } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Phone from "../../img/phone.png";
// import './menu.css';
import styled from "@emotion/styled";

const MobileMenu = (props) => {
  const A = styled.a`
    border: none;
    height: 40px;
    color: #ffffff !important;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    display: inline-block;
    line-height: 35px;
    background-color: #b82e3c;
    margin: 9px;
    padding: 0px 6px 0px 0px;
  `;

  const LI = styled.li`
    // background-color: #B82E3C;
    padding: 10px 20px 0px 20px;
  `;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const menulist = props.menuList.map(function (value, i) {
    return (
      <Link
        href={value[1]}
        className={value[3] + " d-block"}
        onClick={handleClose}
        style={{ padding: "10px 2px 10px 2px", color: "black",borderBottom:'1px solid black' }}
      >
        {value[0]}
      </Link>
    );
  });
  return (
    <Container>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        className="pt-4"
      >
        <Grid xs={8} className="text-left">
          <Link href="/">
            <img
              src={props.siteLogo}
              className="img-fluid w-100"
              style={{ maxWidth: 140 }}
            />
          </Link>
        </Grid>
        <Grid xs={4} className="text-right" >
          <Button
            id="fade-button"
            aria-controls="fade-menu"
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            style={{ color: "#ffffff" }}
          >
            <MenuIcon />
          </Button>
        </Grid>
      </Grid>

      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        className="w-100 px-2"
      >
       
        <LI>{menulist}</LI>
        <A class="px-2">
          <img src={Phone} className="img-fluid" />
          +92 51 220 3122
        </A>
      </Menu>
    </Container>
  );
};

export default MobileMenu;
